import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../slice/userSlice";
import contactusReducer from "../slice/contactUsSlice";
import bannerReducer from "../slice/bannerSlice";
import galleryReducer from "../slice/gallerySlice";
import enquireReducer from "../slice/enquireSlice";
import khajurahoPackageReducer from "../slice/khajurahoPackageSlice";
import serviceReducer from "../slice/serviceSlice";
import itineraryReducer from "../slice/itinerarySlice";
import testimonialReducer from "../slice/testimonialSlice";
import videoReducer from "../slice/videoSlice";
import visitReducer from "../slice/visitSlice";
import bookingReducer from "../slice/bookingSlice";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { watchGetUser } from '../apis/apiHandler';

const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'] // Only persist user for session
};

const rootReducer = combineReducers({
  user: userReducer,
  contactus: contactusReducer,
  banner: bannerReducer,
  gallery: galleryReducer,
  enquire: enquireReducer,
  khajurahoPackage: khajurahoPackageReducer,
  service: serviceReducer,
  itinerary: itineraryReducer,
  testimonial: testimonialReducer,
  video: videoReducer,
  visit: visitReducer,
  booking: bookingReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(watchGetUser);

export const persistor = persistStore(store);

export default store;
